<script>
import Validation from '@/plugins/validation'
import { InputWithObj, Select, CheckboxWithObj } from '@/components/formelements'
import DataTable from '@/components/DataTable'
import { mapState } from 'vuex'

export default {
  name: 'Retailer',
  props: ['id'],
  async mounted() {
    this.$store.dispatch('retailer/RESET')
    await this.$store.dispatch('retailer/SET_RETAILER', this.id)
  },
  data() {
    return {
      ...Validation,
      promoEmailAlert: [
        {
          text: 'NONE',
          vaule: ""
        },
        {
          text: 'Y',
          value: 'yes'
        },
        {
          text: 'N',
          value: 'no'
        }
      ]
    }
  },
  components: {
    InputWithObj,
    CheckboxWithObj,
    Select,
    DataTable
  },
  computed: {
    ...mapState({
      headers: state => state.retailer.headers,
      pRetailData: state => state.retailer.pRetailData,
      orgRetailerInfo: state => state.retailer.orgRetailerInfo,
      retailerInfo: state => state.retailer.retailerInfo,
      listingEndDate: state => state.retailer.listingEndDate,
      retailerType: state => state.retailer.retailerType,
      statusTypes: state => state.search.statusTypes,
      merchantInfo: state => state.merchant.merchantInfo
    }),
    listingEndDateItems() {
      return this.listingEndDate.map( listing => {
        return { text: listing.Name, value: listing.ID }
      })
    },
    retailerTypeItems() {
      return this.retailerType.map( type => {
        return { text: type.Name, value: type.ID }
      })
    },
    getRowStatus: function() {
      if (!this.retailerInfo.RowStatus) return 'Active'
      const status = this.statusTypes.filter( type => type.ID == this.retailerInfo.RowStatus )
      return status[0].Name
    },
  },
  methods: {
    async saveUpdates(){
      if(this.$refs.updateRetailerForm.validate()) {
        if (this.id == 0){
          await this.$store.dispatch('retailer/INSERT_RETAILER')
          this.$router.push({name: 'Retailer', params: { id: this.retailerInfo.ID }})
        } else {
          await this.$store.dispatch('retailer/UPDATE_RETAILER')
        }
      }
    },
  }
}
</script>

<template>
  <v-container fluid>
    <v-row>
      <router-link style="text-decoration: none" class="pa-5" :to="{ name: 'Merchant', params: { id: retailerInfo.MerchantID || merchantInfo.ID } }"> 
        Merchant: {{ retailerInfo.MerchantName || merchantInfo.Name }} ({{ retailerInfo.MerchantID || merchantInfo.ID }})
      </router-link>
    </v-row>
    <v-row >
      <v-col class="pl-6" cols="12" sm="6">
        <v-form ref="updateRetailerForm">
          <v-row>
            <v-col cols="6">
              Retailer ID: {{ orgRetailerInfo.ID }}
            </v-col>
            <v-col cols="6">
              Row Status: <span :class="{ 'green--text font-weight-black': retailerInfo.RowStatus == 1 || retailerInfo.RowStatus == undefined }">{{ getRowStatus }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <InputWithObj :rules="[...required]" form="retailer" field="retailerInfo" objkey="Name" label="Retailer Name" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="8">
              <Select form="retailer" field="retailerInfo" objkey="EmailAlertFlag" :items="promoEmailAlert" label="Default Promotion Email Alert Flag" />
            </v-col>
            <v-col cols="12" sm="4">
              <CheckboxWithObj form="retailer" field="retailerInfo" objkey="PromotionFlag" :value="retailerInfo.PromotionFlag" ifTrue="Y" ifFalse="N" label="Use Promotion Flag" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <InputWithObj form="retailer" field="retailerInfo" objkey="PromotionPageImageLocation" label="Default Promotion Page Image Location" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <InputWithObj form="retailer" field="retailerInfo" objkey="ImageLocation" label="Default Listing Image Location" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <Select form="retailer" field="retailerInfo" objkey="EndDateDisplayTypeID" :items="listingEndDateItems" label="Default EndDate Display Type" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <Select :rules="[...required]" form="retailer" field="retailerInfo" objkey="TypeID" :items="retailerTypeItems" label="Retailer Type" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              Last Updated By <br/> {{ orgRetailerInfo.LastUpdatedBy }}
            </v-col>
            <v-col cols="6">
              Last Updated Date <br/> {{ orgRetailerInfo.LastUpdateDate }}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <router-link to="/merchant/0">
                <v-btn depressed color="accent">
                  <v-icon left>mdi-plus-box</v-icon>Create New Merchant
                </v-btn>
              </router-link>
            </v-col>
            <v-col class="d-flex justify-end" cols="12" md="6">
              <v-btn :disabled="!$store.getters['retailer/retailerChanged']" @click="saveUpdates" width="125px" depressed color="accent">
                <v-icon left>mdi-content-save</v-icon>Save
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
      <v-col cols="12" sm="6">
        <v-card >
          <v-card-title>
            {{ orgRetailerInfo.Name }} PRetailers
          </v-card-title>
        <DataTable :headers="headers" :items="pRetailData" />
        <v-card-actions>
          <v-btn :disabled="id == 0" depressed color="accent" :to="{ name: 'Pretailer', params: { id: '0'}}">
            <v-icon left>mdi-plus-box</v-icon>Create New PRetailer
          </v-btn>
        </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="d-flex justify-space-between flex-column flex-sm-row" cols="12">
        <router-link style="text-decoration: none" :to="{ name: 'MSG Search', params: { id: retailerInfo.ID, pretailerId: 0, storeId: 0}}">
          <v-btn :disabled="!retailerInfo.ID" depressed color="accent">
            MSG Search
          </v-btn>
        </router-link>
        <router-link style="text-decoration: none" :to="{ name: 'Site Filter', params: { id: retailerInfo.ID || 0 }}">
          <v-btn depressed color="accent">
            Site Search
          </v-btn>
        </router-link>
        <router-link style="text-decoration: none" :to="{ name: 'Promotion Groups', params: { id: retailerInfo.ID }}">
          <v-btn :disabled="!retailerInfo.ID" depressed color="accent">
            Promotion Group
          </v-btn>
        </router-link>
        <router-link style="text-decoration: none" :to="{ name: 'Retailer Tags', params: { id: retailerInfo.ID }}">
          <v-btn :disabled="!retailerInfo.ID" depressed color="accent">
            Retailer Tag Search
          </v-btn>
        </router-link>
      </v-col>
    </v-row>
  </v-container>
</template>
